import * as actions from './inventoryInvoice/actions'
import * as mutations from './inventoryInvoice/mutations'
import * as getters from './inventoryInvoice/getters'

import { dataProps } from './inventoryInvoice/properties'

const state = {
    list: [],
    nav: {
        page_number: 1, had_results: false,
        limit: 10,
        total: 0,
        sort_column_name: 't1.id',
        sort_direction: 1, search: ''
    },
    outstanding_list: [],
    props: JSON.parse(JSON.stringify(dataProps))
}

export default {
    state,
    getters,
    mutations,
    actions
}


// WEBPACK FOOTER //
// ./src/store/modules/inventoryInvoice.js